import SentiusCircleCard from '@components/card/SentiusCircleCard'
import Column from '@components/layout/Column'
import Row from '@components/layout/Row'
import useMediaQuery, { maxWidthQueries, minWidthQueries } from '@operations/utils/useMediaQuery'
import React from 'react'
import styled, { useTheme } from 'styled-components'

const StyledTitle = styled.h2`
  width: auto;
  color: ${({ theme }) => theme.colors.white};
  padding: 1rem 6rem;
  clip-path: polygon(0 0, 100% 0, 80% 100%, 20% 100%);
  background: ${({ theme }) => theme.colors.black};
`
const StyledArrow = styled.div`
  color: ${({ theme }) => theme.colors.lightGrey};
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: flex-start;
  height: auto;
  width: 100%;
  img {
    width: 50px;
    transform: rotate(90deg);
  }
  margin: 1rem 0;
  @media ${minWidthQueries.md} {
    width: auto;
    margin: 0;
    justify-content: center;
    height: 100px;
    position: absolute;
    top: calc(50% - 25px);
    transform: translate(-50%, -50%);
    img {
      width: 80px;
      transform: none;
    }
  }
`
const StyledOverlay = styled.div`
  content: '';
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  background: rgba(50, 50, 50, 70%);
`

const Evolutions = ({ evolutions }) => {
  const isMobile = useMediaQuery(maxWidthQueries.sm)
  const theme = useTheme()
  const evolutionsLength = evolutions.length
  let columnsWidth = evolutionsLength === 3 && '33%'
  if (evolutionsLength === 2) columnsWidth = '50%'
  return (
    <Row
      align="center"
      background={{
        backgroundImage: `url(${theme.images.darkPattern})`,
      }}
      boxShadow={`0px 8px 13px -7px ${theme.colors.teal}`}
      justify="center"
      padding={isMobile ? '0 1rem 1rem' : '0 2rem 2rem'}
      position="relative"
    >
      <StyledOverlay />
      <StyledTitle>Evolutions</StyledTitle>
      <Row justify="space-between">
        {evolutions.map((evo, index) => {
          return (
            <Column
              key={evo.id}
              direction={isMobile ? 'row' : 'column'}
              justify="center"
              position="relative"
              width={isMobile ? '100%' : columnsWidth}
            >
              {evo.sentius.map(s => {
                return (
                  <div
                    key={s.id}
                    style={{
                      position: 'relative',
                      width: isMobile && evo.sentius.length >= 2 ? '50%' : '100%',
                    }}
                  >
                    {index !== 0 && (
                      <StyledArrow>
                        {isMobile && evo.level && evo.level !== 0 && <div>lvl. {evo.level}</div>}
                        <img alt="evolution arrow" src="/images/arrow.png" />
                        {!isMobile && evo.level && evo.level !== 0 && <div>lvl. {evo.level}</div>}
                      </StyledArrow>
                    )}
                    <SentiusCircleCard
                      cardImage={s.sideImage}
                      elements={s.element}
                      hoverImage={s.frontImage}
                      name={s.name}
                      number={s.number}
                      slug={s.slug}
                    />
                  </div>
                )
              })}
            </Column>
          )
        })}
      </Row>
    </Row>
  )
}

export default Evolutions
